import { SHOW_MODAL } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case SHOW_MODAL:
            return action.payload;
        default:
            return state;
    }
}